import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

import { NoticiasDetalheComponent } from './noticias-detalhe/noticias-detalhe.component';
import { NoticiasComponent } from './noticias.component';

import { NoticiasService } from './shared/noticias.service';
import { NoticiasListaComponent } from './shared/noticias-lista/noticias-lista.component';
import { NoticiasListaHorizontalComponent } from './shared/noticias-lista-horizontal/noticias-lista-horizontal.component';
import { WpConteudoComponent } from './shared/wp-conteudo/wp-conteudo.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
  ],
  declarations: [
    NoticiasComponent,
    NoticiasDetalheComponent,
    NoticiasListaComponent,
    NoticiasListaHorizontalComponent,
    WpConteudoComponent,
  ],
  exports: [NoticiasListaComponent, NoticiasListaHorizontalComponent, WpConteudoComponent ],
  providers: [ NoticiasService ],
})
export class NoticiasModule { }
